import { tw } from "@careinfo/tailwind";
import { useFormContext } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import CheckBox from "../../shared/Checkbox";
import Combobox from "../../shared/Combobox";
import TextField from "../../shared/TextField";
import { INavigation } from "../../types/interface";

export default function NavigationForm() {
  const { control } = useFormContext<INavigation>();

  return (
    <div className={tw`grid grid-cols-2 gap-4 mt-6`}>
      <TextField
        control={control}
        name="name"
        placeholder="Enter name of navigation"
        label="Name"
      />
      <TextField
        control={control}
        name="path"
        placeholder="Enter path for navigation"
        label="Path"
      />
      <Combobox
        control={control}
        name="pages"
        url={APIS.PAGE}
        queryKey="Page"
        label="Page"
        dataLabel="title"
      />
      <div className={tw`flex items-center gap-x-6`}>
        <CheckBox control={control} name="is_external" label="Is External" />
        <CheckBox control={control} name="is_redirect" label="Is Redirect" />
      </div>
    </div>
  );
}
